import { render, staticRenderFns } from "./Beta.vue?vue&type=template&id=7611cae1&scoped=true&"
import script from "./Beta.vue?vue&type=script&lang=js&"
export * from "./Beta.vue?vue&type=script&lang=js&"
import style0 from "./Beta.vue?vue&type=style&index=0&id=7611cae1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7611cae1",
  null
  
)

export default component.exports